import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
    width: 100%;
  `
);

export const StyledContentSection = styled('section')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledContentList = styled('ul')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    list-style-type: none;
    margin: 0;
    padding: 0;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledContentListItemAlignStart = styled('li')(
  ({ theme }) => css`
    display: flex;

    &::before {
      background-image: url(${theme.icons.tickIcon});
      background-repeat: no-repeat;
      background-size: ${theme.spacing('1XL')} ${theme.spacing('1XL')};
      content: '';
      display: block;
      height: ${theme.spacing('1XL')};
      margin-right: ${theme.spacing('SMALL')};
      width: ${theme.spacing('1XL')};
    }
  `
);

export const StyledContentListItemAlignCenter = styled(StyledContentListItemAlignStart)`
  align-items: center;
`;

export const StyledSpaceBetweenText = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export const StyledRightAlignedText = styled('div')`
  display: flex;
  justify-content: end;
`;

export const StyledSeparator = styled('div')(
  ({ theme }) => css`
    background-color: ${theme.palette.main.product_blue};
    border: none;
    height: 1px;
    margin: 0;
    width: 100%;
  `
);

export const StyledPolicyDetailsNumericalValue = styled('div')`
  flex-shrink: 0;
`;

export const StyledContractCancelLink = styled('div')(
  ({ theme }) => css`
    margin-top: ${theme.spacing('LARGE')};
  `
);
